import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const polarisProductFinancialYearSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-polaris-settings-financial-year", jiraSpaEntry: "async-polaris-ideas" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
